import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import { setSelectedSite } from '../redux/customerSite/customerSiteActions';
import SelectWithModal from './SelectWithModal/SelectWithModal';

class ExtranetSideBarContent extends Component {

    onSiteChange(value) {
        this.props.setSelectedSite(value.value, this.props.sites.sites);
    }

    getSiteModel(site) {
        return {
            value: site.id,
            label: site.name
        }
    }

    render() {
        let selectedSite = this.props.sites.sites.find(s => s.id === this.props.sites.selectedSite)

        if (!selectedSite)
            return null;

        let selectedSiteModel = this.getSiteModel(selectedSite);

        return (
            <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                <SelectWithModal
                    inputProps={{ name: "site", id: "site" }}
                    className="full_size"
                    style={{
                        backgroundColor: "#F5F6F5",
                        borderRadius: 4,
                        fontSize: 16,
                    }}
                    placeholder={"Site"}
                    value={this.props.sites.sites.length > 0 && selectedSiteModel ? selectedSiteModel : ''}
                    id="site"
                    onValidate={this.onSiteChange.bind(this)}
                    name="site"
                    menuPlacement="auto"
                    classNamePrefix="select"
                    options={this.props.sites.sites.map(this.getSiteModel)}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        sites: state.sites,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setSelectedSite: (selectedSiteId, allSites) => dispatch(setSelectedSite(selectedSiteId, allSites))
    };
};

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(ExtranetSideBarContent);
